import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { analytics } from "@heycatch/sdk";
import "@/index.css";
import App from "@/App";

// HeyCatch analytics.
//
// This must stay a STATIC import at module scope in the entry file, and must run
// before anything renders:
//  - nothing is queued before init, so an init inside a component would leave
//    every other landing page untracked;
//  - the SDK forwards HeyCatch's reserved single-character short-link paths
//    (/a-/z, /0-/9) the moment the bundle evaluates, i.e. before React Router's
//    catch-all route can redirect them and drop the campaign parameters.
// init is idempotent and a no-op during SSR, so no window guard is needed. The
// project key is publishable by design, which is why it is inlined rather than
// read from an env var.
//
// Autocapture handles pageviews, clicks and SPA route changes from here on. Our
// own first-party tracking in src/lib/analytics.js is unaffected and still feeds
// the Sponsor Me admin dashboard; business outcomes reach HeyCatch through
// src/lib/heycatch.js, which enforces the project's privacy contract.
analytics.init({
  projectKey: "hck_pk_xIwRoSNWOa4iZBzPG5mnr4RLyDNmbgAL",
  install: {
    framework: "react",
    frameworkVersion: "19",
    agent: "other",
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
